export default "__VITE_ASSET__C4p5cgnt__"